import { Type } from '@angular/core';
import { Routes } from '@angular/router';
import type { PreferenceAgentChatComponent } from
  './shared/components/preference-agent-chat/preference-agent-chat.component';

export const routes: Routes = [
  {
    loadComponent: () => import('./shared/components/client-form/client-form.component')
      .then(m => m.ClientFormComponent),
    path: '',
    pathMatch: 'full',
  },
  {
    loadComponent: () => import('./shared/components/client-form/client-form.component')
      .then(m => m.ClientFormComponent),
    path: 'forms/:id',
  },
  {
    loadComponent: (): Promise<Type<PreferenceAgentChatComponent>> =>
      import('./shared/components/preference-agent-chat/preference-agent-chat.component')
        .then((m): Type<PreferenceAgentChatComponent> => m.PreferenceAgentChatComponent),
    path: 'agent/:tenantId/:slug',
  },
];
